import { Button } from '../../../../../../../components';

type EditMetadataFooterProps = {
  valid: boolean;
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
};

export const EditMetadataFooter: React.FC<EditMetadataFooterProps> = ({
  valid,
  saving,
  onCancel,
  onSave,
}) => {
  return (
    <div className="flex flex-row justify-end items-center gap-x-3 w-full">
      <Button
        size="medium"
        type="contrast"
        label="Cancel"
        className="min-w-[10rem] text-main"
        onClick={onCancel}
      />
      <Button
        size="medium"
        disabled={!valid || saving}
        loading={saving}
        className="min-w-[10rem]"
        label="Save"
        onClick={onSave}
      />
    </div>
  );
};
